import { createApp } from 'vue';

// bootstrap
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue3-date-time-picker/dist/main.css';

// sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import partnerSwal from './store/partnerSwal';

// Custom files
import { userPermission } from './store/userPermission';
import format from './store/format';

// Custom components
import uiComponents from './store/uiComponents';

import App from './App.vue';
import router from './router';
import mitt from 'mitt';

const app = createApp(App);
const emitter = mitt();
//app.component('Datepicker', Datepicker);

app.use(router);
app.use(VueSweetalert2);
app.config.globalProperties.$userPermission = userPermission;
app.config.globalProperties.$partnerSwal = partnerSwal;
app.config.globalProperties.$format = format;
app.config.globalProperties.emitter = emitter;
app.component('DefaultLoader', uiComponents.DefaultLoader);
app.component('NoDataMessage', uiComponents.NoDataMessage);

app.mount('#app');
